module.exports = __webpack_public_path__ + "Poppins-Bold.81873d33ae530a7a1bee.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Bold.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Bold.woff
// module chunks = styles